import { render } from "./Blog3.vue?vue&type=template&id=ca3addf8"
import script from "./Blog3.vue?vue&type=script&lang=js"
export * from "./Blog3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__